const RTPURL="https://arena.rtp.pt";
import axios from "axios";

export default {

    /*
    * Gets news from json news feed.
    * Parameters:
    *  - post_type (wordpress post type - any)
    *  - quantity (quantity of articles to retrieve)
    *  - cat (category - csgo)
    * */
    getNews(searchdata=null){

        let qs="";
        if(searchdata!==null){
            qs=Object.keys(searchdata).map(key => key + '=' + encodeURI(searchdata[key])).join('&');
        }

        if(qs!==""){
            qs="?"+qs;
        }

        let api=axios.create({
            RTPURL,
            headers: {'Accept':'application/json'}
        });

        return api.get(RTPURL+"/rss-feed/"+qs);

    },

    getEvents(quantity=null){
        let qs="";
        if(quantity!==null){
            qs="?quantity="+quantity;
        }

        let api=axios.create({
            RTPURL,
            headers: {'Accept':'application/json'}
        });

        return api.get(RTPURL+"/rss-feed-eventos/"+qs);
    }



}